import { apiPipeline } from "api/api-pipeline";

export interface PipelineModeloDTO {
  id?: number;
  nome: string;
  descricaoCurta?: string;
  icone?: string;
  cor?: string;
  convenio?: string;
  tipoOperacao?: string;
  sequenciaBloco?: string;
  status: "ATIVO" | "INATIVO";
  customerIdCreated?: number;
  userIdCreated?: number;
  createdAt?: string;
  updatedAt?: string;
}

type ModeloPayload = Omit<
  PipelineModeloDTO,
  "id" | "createdAt" | "updatedAt" | "customerIdCreated" | "userIdCreated"
>;

export class ModelosPipelineEndpoints {
  static list(convenio?: string, tipoOperacao?: string) {
    const params: Record<string, string> = {};
    if (convenio) params.convenio = convenio;
    if (tipoOperacao) params.tipoOperacao = tipoOperacao;
    return apiPipeline.get<PipelineModeloDTO[]>("/templates-pipeline", {
      params: Object.keys(params).length ? params : undefined
    });
  }

  static create(data: ModeloPayload) {
    return apiPipeline.post<PipelineModeloDTO>("/templates-pipeline", data);
  }

  static remove(id: number) {
    return apiPipeline.delete(`/templates-pipeline/${id}`);
  }

  static updateEstrutura(id: number, data: ModeloPayload) {
    return apiPipeline.put<PipelineModeloDTO>(
      `/templates-pipeline/update/estrutura/${id}`,
      data
    );
  }

  static patchStatus(id: number, status: "ATIVO" | "INATIVO") {
    return apiPipeline.patch<PipelineModeloDTO>(
      `/templates-pipeline/status/${id}`,
      undefined,
      { params: { status } }
    );
  }
}
